<script lang="ts" setup>
import { Menu } from '~/api/drupal/useMenu'
defineProps<{
  menu: Menu
}>()
</script>
<template>
  <ul class="menu text-xsmall">
    <li v-for="item in menu" :key="item.id">
      <NuxtLink :to="item.url" :target="item.target">{{ item.title }} </NuxtLink>
    </li>
  </ul>
</template>
<style lang="scss" scoped>
.menu {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  gap: 10px 24px;
  @include breakpoint(ts) {
    flex-direction: row;
    flex-wrap: wrap;
    align-items: center;
  }
}
</style>
